import { ApolloError } from "@apollo/client";
import { Layout } from "../../UI/Layout/Layout.tsx";
import { ScreenTitleBlock } from "../../UI/Layout/ScreenTitleBlock.tsx";
import { Card } from "../../UI/Card.tsx";
import { LoadingRows } from "../../UI/Loading/LoadingRows.tsx";
import { useMessagePopupController } from "../../UI/MessagePopup/useMessagePopupController.ts";
import { ErrorMessagePopup } from "../../UI/MessagePopup/ErrorMessagePopup.tsx";
import { BreadCrumbsWrapper } from "../../UI/Layout/BreadCrumbsWrapper.tsx";
import { BreadCrumbsItem } from "../../UI/Layout/BreadCrumbsItem.tsx";
import { useToCoursePdfs } from "../../CoursePdf/useToCoursePdfs.ts";
import { useAllUserGroups } from "../../UserGroup/useAllUserGroups.ts";
import {
  OnboardingLivePdfForm,
  OnboardingLivePdfFormInputs,
} from "./OnboardingLivePdfForm.tsx";
import { useOnboardingLivePdfs } from "./useOnboardingLivePdfs.ts";
import { useOnboardingLivePdfParamsOrThrow } from "./useOnboardingLivePdfParamsOrThrow.ts";

export function EditOnboardingLivePdfScreen() {
  const { userGroupId } = useOnboardingLivePdfParamsOrThrow();
  const { pdfs, loading, upsertPdf } = useOnboardingLivePdfs();
  const { userGroups } = useAllUserGroups();
  const current = pdfs.find((p) => p.userGroupId === userGroupId);
  const { toCoursePdfs } = useToCoursePdfs();
  const { show, title, description, showPopup } = useMessagePopupController(
    4 * 1000,
  );

  async function onSave(input: OnboardingLivePdfFormInputs) {
    try {
      await upsertPdf(input.userGroupId, input.pdfUrl);
    } catch (e) {
      const error = e as ApolloError;
      showPopup("Error", error?.message ?? "Unknown error");
      return;
    }
    toCoursePdfs();
  }

  return (
    <>
      <ErrorMessagePopup title={title} description={description} show={show} />
      <Layout>
        <Card>
          <ScreenTitleBlock
            title={"Edit Onboarding Live PDF"}
            breadCrumbs={
              <BreadCrumbsWrapper>
                <BreadCrumbsItem title={"Course PDFs"} onClick={toCoursePdfs} />
                <BreadCrumbsItem title={"Edit"} />
              </BreadCrumbsWrapper>
            }
          />
        </Card>
        <div className={"mt-4"}>
          <Card>
            {loading && !current ? (
              <LoadingRows />
            ) : (
              <OnboardingLivePdfForm
                userGroups={userGroups}
                disabledMap={{ userGroupId: true }}
                onSave={onSave}
                defaultValues={{ userGroupId, pdfUrl: current?.pdfUrl ?? "" }}
              />
            )}
          </Card>
        </div>
      </Layout>
    </>
  );
}
